/**
 * Campus Framework API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@bitapp.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum ExemptionReason {
    Sickness = 'sickness',
    MaternityLeave = 'maternity_leave',
    PersonalProblems = 'personal_problems',
    DmRequest = 'dm_request',
    Retirement = 'retirement',
    PoorlyCommerciallyActive = 'poorly_commercially_active',
    ScheduledExit = 'scheduled_exit',
    Convention = 'convention',
    Plenary = 'plenary',
    EmptyRegisterSubscription = 'empty_register_subscription',
    RegisterSubscriptionInCertificationYear = 'register_subscription_in_certification_year',
    ExternalCertificationTestPassedInCertificationYear = 'external_certification_test_passed_in_certification_year',
    Other = 'other'
};

